var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.072 62.1611C89.072 62.1611 89.1872 61.7061 89.5987 61.5851C90.0103 61.4641 90.249 61.6261 90.249 61.788",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9404 91.6676C50.192 91.6676 50.759 91.4884 51.0873 90.9079C51.1424 90.8119 51.2294 90.6468 51.2294 90.5847C51.2294 90.5847 50.7571 90.6487 49.9404 90.417",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5359 84.3262C25.5359 84.4964 25.6152 84.4855 26.0914 84.6283C26.2623 84.6795 29.2671 85.5146 33.0719 86.5694C33.1948 86.6039 33.3189 86.7051 33.4437 86.7396C35.8597 87.4097 38.5637 88.1585 41.0565 88.8478C41.1717 88.8798 41.2856 88.8478 41.3996 88.8759C45.7279 90.0727 49.3356 91.0679 49.5314 91.1159C50.0312 91.235 50.6572 91.1217 51.0034 91.0436",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5842 23.6992L57.9333 5.79395",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8006 25.816L17.854 5.26562",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0061 26.3766L58.3495 24.3389",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3446 56.9092L25.0259 63.2138",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1855 57.959L89.2102 61.8739",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3716 63.7949L50.0967 68.714",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.28 68.8193L51.2295 90.5851",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7549 61.876C89.8829 61.9176 90.0454 62.0001 90.0454 62.5051C90.0454 63.3281 90.0454 81.7467 90.0454 82.098",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1626 68.5957C50.3546 68.6341 51.2353 68.8811 51.5707 68.821",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5724 68.6367C51.5424 68.3654 51.2416 68.1074 50.5657 68.3263C50.023 68.5023 50.0384 68.8927 50.0384 69.166C50.0384 70.7474 49.9405 90.1362 49.9405 90.5074C49.9405 90.8786 49.9193 91.2831 51.0022 91.0431",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3523 57.479C64.9389 57.415 64.1894 57.351 64.1856 57.959C64.1753 59.559 64.1216 66.5906 64.1216 66.5906",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.374 63.6978C25.374 63.454 25.9231 63.2709 26.7967 63.4136C27.6703 63.5564 49.4079 67.7509 50.5356 67.9628C51.3862 68.1221 51.5724 68.1285 51.5724 68.6367V68.8197C51.5724 68.8197 89.4361 62.0927 89.5782 62.0722C89.7203 62.0517 89.8982 61.9967 89.822 61.9096C89.7785 61.8591 89.3196 61.7471 89.3196 61.7471",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0481 81.5728C90.0481 81.5728 90.3732 81.5088 90.3732 81.0851C90.3732 80.6615 90.2509 62.0131 90.2509 61.7866C90.2509 61.56 90.1869 61.441 89.3364 61.2989C88.4858 61.1568 65.3543 57.4781 65.3543 57.4781C65.3543 57.4781 65.3338 55.6688 65.3133 55.425C65.2929 55.1811 59.1553 24.449 59.1553 24.449H58.4417C58.3201 24.449 58.1383 23.7379 58.5844 23.697C58.7259 23.6818 58.8683 23.6752 59.0106 23.6771C59.1738 23.6771 71.7133 22.2135 72.5466 22.1117C73.3799 22.0099 75.5546 21.2989 75.5546 18.8803C75.5546 17.2842 74.0039 13.8544 71.0631 10.9136C69.2135 9.06402 67.5527 8.10594 65.3722 7.13314C61.5924 5.4461 57.9335 5.78914 57.9335 5.78914C57.9335 5.78914 57.8695 5.46402 57.4458 5.46402C57.0221 5.46402 17.8746 5.05762 17.8746 5.05762L17.8561 5.26498C17.8561 5.26498 14.1863 5.1229 11.3613 7.7245C8.53638 10.3261 5.99494 15.6906 5.76326 21.2995C5.68198 23.2714 7.03046 24.9066 8.39238 25.0288C9.7543 25.1511 18.3623 25.7725 18.6881 25.7923C19.0138 25.8122 19.0138 26.1379 19.0138 26.28C19.0138 26.4221 18.9409 26.625 18.0058 26.664C18.0058 26.664 24.5217 61.5005 24.6433 62.1712C24.7649 62.8419 25.1514 63.4922 25.3748 63.6951C25.3748 63.6951 25.3549 64.3459 25.3549 65.24C25.3549 66.1341 25.5361 84.1027 25.5361 84.3261C25.5361 84.5495 25.3735 84.4483 25.3735 84.7325V85.0173C25.3735 85.0173 49.2545 91.5415 49.5796 91.6227C49.9047 91.704 50.6772 91.7245 52.2221 91.3181C53.7671 90.9117 89.5981 82.2173 90.0461 82.0951L90.0481 81.5728Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.4a10dc01.svg";
export { ForwardRef as ReactComponent };